export function getCookie(cookieName) {
  let name = cookieName + '=';
  let decodedCookies = decodeURIComponent(document.cookie);
  let cookieArray = decodedCookies.split(';');

  let foundCookie = cookieArray.find(cookie => {
    let trimmed = cookie.trim();
    return trimmed.startsWith(name);
  })?.trim();

  if (!foundCookie) {
    return '';
  }

  return foundCookie.substring(name.length);
}

export function getVisitorSession() {
  const vsCookie = getCookie('vs');
  return vsCookie?.slice(2);
}